import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { DataType, primitiveTypes } from "../TypeDefinitions";
import { loopIterationStart } from "../../Runtime/RuntimeExecution";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import {
  variableInPropertyName,
  variableOutPropertyName,
  variablesPropertyLabel
} from "../../UserDefinedSchemaManagement/LoopVariableEditor";

const listInputName = "list";
const itemOutputName = "item";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.forEach,
  category: NodeTypeCategory.lists,
  label: "Loop",
  controlInputs: [{ name: "begin" }],
  controlOutputs: [{ name: "done" }, { name: "each", startsLoop: true }],
  dataInputs: [
    { name: listInputName, type: DataType.OBJECTLIST },
    {
      name: variableInPropertyName,
      type: DataType.OBJECT,
      label: variablesPropertyLabel,
      required: false,
      enabled: false
    }
  ],
  dataOutputs: [
    { name: itemOutputName, type: DataType.OBJECT },
    { name: variableOutPropertyName, label: variablesPropertyLabel, type: DataType.OBJECT, enabled: false }
  ],
  listToItem: true,
  size: NodeSize.Small,
  nodeConfigProperties: [
    {
      name: "schema",
      label: "Type",
      propertyType: NodeConfigPropertyType.DataType,
      options: {
        dataTypes: ([] as DataType[]).concat(primitiveTypes).concat([DataType.OBJECT, DataType.OBJECTREFERENCE]),
        dataProperties: [listInputName, itemOutputName]
      }
    },
    {
      name: "loopVariableEditor",
      label: "",
      propertyType: NodeConfigPropertyType.LoopVariableEditor,
      schemaSourceSystemType: {
        sourceSystem: DocumentSchemaSource.userDefined,
        dataParams: [variableInPropertyName, variableOutPropertyName]
      }
    }
  ],
  evaluate: function (
    input: { [name: string]: string | number | boolean | object | object[] },
    nodeProperties?: any
  ): { output: { [name: string]: string | number | boolean | object | object[] }; activeControlHandleIds: string[] } {
    let activeControl = "each";

    loopIterationStart();

    if (!nodeProperties.itemIndex) {
      nodeProperties.itemIndex = 0;
    }

    if (nodeProperties.breakLoop || nodeProperties.itemIndex >= (input.list as object[]).length) {
      activeControl = "done";
      delete nodeProperties.itemIndex;
    }

    return {
      output: { item: (input.list as object[])[nodeProperties.itemIndex++] as unknown as any },
      activeControlHandleIds: [activeControl]
    };
  }
});

export const ForEachNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
